<template>
  <div class="Evaluationmanagement">
    <van-nav-bar left-arrow fixed placeholder @click-left="onClickLeft" v-show="!inpshow" ref="navBar">
      <van-icon name="search" slot="right" @click="searchCancel()" />
      <span slot="title">项目评估列表</span>
    </van-nav-bar>

    <van-sticky v-show="inpshow" ref="searchDom">
      <van-search v-model="inpVal" show-action placeholder="请输入手机号搜索" @search="onSearch" @cancel="searchCancel()"
        class="back-tran" />
    </van-sticky>
    <van-sticky :offset-top="navBarHeight">
      <div class="head">
        <div>项目名称</div>
        <div class="phone">手机号</div>
        <div>进度</div>
      </div>
    </van-sticky>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-for="(item,index) in MemberList" :key="item.id" class="MemberList">
        <div class="list">
          <div class="time van-multi-ellipsis--l2">
            {{item.company||'无'}}-{{item.type === '1'?'专利':item.type === '2'?'商标':'版权'}}</div>
          <div>{{item.phone}}</div>
          <div>{{item.jindu}}</div>
        </div>
        <div class="btn">
          <van-button round type="info" plain color="#333" class="personal" block @click="lookInfo(item,false)">修改
          </van-button>
          <van-button round type="info" plain color="#333" class="personal" block @click="lookInfo(item,true)"
            v-show="!item.dock_status*1">查看</van-button>
          <van-button round type="info" plain color="#333" class="personal" block @click="delese(item.id)">删除
          </van-button>
          <van-button round type="info" plain color="#2DADB1" class="personal" block @click="suredocked(item.id,index)"
            :disabled="item.dock_status==1">{{item.dock_status*1?'已对接':'确认对接'}}</van-button>
        </div>
      </div>
    </van-list>
    <!-- 修改/查看详情 -->
    <van-popup v-model="isLookShow" round close-icon="close" closeable position="bottom" :style="{ height: '90%' }">
      <h5 class="popup-title">详细信息</h5>
      <div class="information">
        <template v-if="isLook">
          <div class="popup-header">用户信息</div>
          <p>手机号：{{userLook.phone}}</p>
          <p>公司名称：{{userLook.gsmc}}</p>
          <p>区域：{{userLook.province}}</p>
          <p>个人职务：{{userLook.grzw}}</p>
          <p style="margin-bottom:20px">注册时间：{{userLook.create_time}}</p>
        </template>

        <div class="popup-header">项目信息</div>
        <p>
          项目名称：{{this.lookData.company||'无'}}-{{this.lookData.type === '1'?'专利':this.lookData.type === '2'?'商标':'版权'}}
        </p>
        <p>项目进度</p>
        <div class="technology" v-for="item in ListingData" :key="item.id">
          <div>{{item.title}}</div>
          <div class="progress">
            <div class="process" v-for="item1 in item.child" :key="item1.id">
              <div @click.stop="shows(item1)">
                <span class="js">{{item1.title}}</span>&nbsp;
                <van-icon name="arrow" />
              </div>
              <p class="progr">{{item1.progress=='0'?'未开始':item1.progress =='100'?'已完成':'进行中'}}</p>
              <div class="proce" v-show="progressId === item1.id" v-if="!isLook">
                <select name id @change="selectChange" v-model="proxx">
                  <option value="z">请选择</option>
                  <option :value="items.name" v-for="(items,index) in lists" :key="index">{{items.value}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <p>
          <span>上传报告：</span>
          <input type="text" class="photopath" placeholder="未选择任何文件" v-model="photopath" readonly="readonly" />
          <van-uploader :disabled="isLook?true:false" :before-read="beforeRead">
            <van-button v-show="!isLook" color="#2DADB1" plain round size="large">选择文件</van-button>
          </van-uploader>
        </p>
        <!-- <p>创建时间：{{userdata.create_time+'000'-0|filterTime}}</p> -->
        <p>创建时间：{{userdata.create_time}}</p>
        <div class="btns" v-if="!isLook">
          <van-button type="primary" block color="#2DADB1" @click="ttjj">提交</van-button>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import {
  assessmentList,
  assessmentListDetails,
  modifyAssessmentListDetails,
  docked,
  delsteass,
  assessmentListDetailsUp
} from '@/api/assessment.js'
import { updateUserPhoto } from '@/api/user.js'
import { getUserInfo } from '@/api/member.js'
import delItem from '@/utils/delitem.js'
export default {
  name: 'evaluationmanagement',
  props: {},
  data () {
    return {
      MemberList: [],
      userdata: {}, // 查看--用户信息
      ListingData: [], // 信息详情
      photopath: '', // 报告路径
      id: '', // 点击要修改的项目id
      ListingProgress: {
        child1: [
          {
            id: 0,
            progress: '0',
            title: '基本信息录入'
          },
          {
            id: 1,
            progress: '0',
            title: '评估对象筛选'
          },
          {
            id: 2,
            progress: '0',
            title: '问卷填写'
          },
          {
            id: 3,
            progress: '0',
            title: '资料上传'
          },
          {
            id: 4,
            progress: '0',
            title: '现场考察'
          }
        ],
        child2: [
          {
            id: 5,
            progress: '0',
            title: '技术检索',
            proceslist: [
              { name: 'a', value: '未开始' },
              { name: 'b', value: '进行中' },
              { name: 'c', value: '已完成' }
            ]
          },
          {
            id: 6,
            progress: '0',
            title: '技术分析',
            proceslist: [
              { name: 'a', value: '未开始' },
              { name: 'b', value: '进行中' },
              { name: 'c', value: '已完成' }
            ]
          },
          {
            id: 7,
            progress: '0',
            title: '法律分析',
            proceslist: [
              { name: 'a', value: '未开始' },
              { name: 'b', value: '进行中' },
              { name: 'c', value: '已完成' }
            ]
          },
          {
            id: 8,
            progress: '0',
            title: '市场分析',
            proceslist: [
              { name: 'a', value: '未开始' },
              { name: 'b', value: '进行中' },
              { name: 'c', value: '已完成' }
            ]
          },
          {
            id: 9,
            progress: '0',
            title: '时效分析',
            proceslist: [
              { name: 'a', value: '未开始' },
              { name: 'b', value: '进行中' },
              { name: 'c', value: '已完成' }
            ]
          },
          {
            id: 10,
            progress: '0',
            title: '风险分析',
            proceslist: [
              { name: 'a', value: '未开始' },
              { name: 'b', value: '进行中' },
              { name: 'c', value: '已完成' }
            ]
          },
          {
            id: 11,
            progress: '0',
            title: '财务分析',
            proceslist: [
              { name: 'a', value: '未开始' },
              { name: 'b', value: '进行中' },
              { name: 'c', value: '已完成' }
            ]
          }
        ],
        child3: [
          {
            id: 12,
            progress: '0',
            title: '评估估算'
          },
          {
            id: 13,
            progress: '0',
            title: '报告审核'
          },
          {
            id: 14,
            progress: '0',
            title: '意见反馈'
          },
          {
            id: 15,
            progress: '0',
            title: '项目完成'
          },
          {
            id: 16,
            progress: '0',
            title: '附加服务'
          }
        ]
      },
      lists: [
        { name: 'a', value: '未开始' },
        { name: 'b', value: '进行中' },
        { name: 'c', value: '已完成' }
      ],
      proxx: 'z', // 默认展示下拉框中的选项
      progressId: '-1', // 进度ID
      assprogress: {
        id: '',
        progress: ''
      },
      lookData: {}, // 存储点击的项目
      userLook: {}, // 查看详情里的用户信息
      isLook: false, // 是否为查看详情
      isLookShow: false, // 修改详情/查看详情展示框
      inpshow: false, // 搜索框展示/隐藏
      inpVal: '', // 搜索内容
      searchVal: '', // 前一次搜索内容
      isSearch: false, // 判断要获取搜索数据还是所有数据
      page: 0,
      loading: false, // 下拉加载
      finished: false, // 下拉加载--截止
      isData: false, // 是否停止加载 true：停止加载，false：继续加载
      navBarHeight: 44 // 头部高度
    }
  },
  watch: {
    isLookShow (newV, oldV) {
      if (!newV) {
        this.progressId = '-1'
      }
    },
    inpshow (newVal) {
      this.getScrollTop()
    }
  },
  mounted () {
    this.getScrollTop()
  },
  methods: {
    onClickLeft () {
      this.$router.back()
    },
    // 获取头部顶部高度
    getScrollTop () {
      this.$nextTick(() => {
        if (this.inpshow) {
          this.navBarHeight = this.$refs.searchDom.$el.offsetHeight
        } else {
          this.navBarHeight = this.$refs.navBar.$el.offsetHeight
        }
      })
    },

    // 分页加载
    async onLoad (type) {
      if (type) {
        this.MemberList = []
        this.page = 0
        this.finished = false
        this.loading = true
        this.isData = false
      }
      this.page += 1
      if (this.isSearch) {
        await this.getAssessmentList(this.page, this.searchVal)
      } else {
        await this.getAssessmentList(this.page)
      }
      await this.$delay(800)
      this.loading = false
      if (this.isData) {
        this.loading = false
        this.finished = true
      }
    },
    // 获取列表数据
    async getAssessmentList (page, phone) {
      try {
        const data = await assessmentList(page, phone)
        if (data.error_code === 1) {
          this.MemberList = [...this.MemberList, ...data.data]
          if (data.data.length < 10) this.isData = true
        } else {
          this.$toast('搜索失败')
        }
      } catch (error) {
        this.isData = true
      }
    },
    // 确认对接
    async suredocked (id, ind) {
      try {
        const data = await docked(id)
        if (data.error_code === 1) {
          this.$toast('对接成功')
          this.MemberList[ind].dock_status = '1'
        } else {
          this.$toast('对接失败')
        }
      } catch (error) {
        return error.message
      }
    },
    // 删除
    delese (id) {
      this.$dialog
        .confirm({
          title: '是否确认删除?',
          confirmButtonColor: '#2DADB1'
        })
        .then(async () => {
          try {
            const data = await delsteass(id)
            if (data.error_code === 1) {
              this.MemberList = delItem(this.MemberList, id)
              this.$toast('删除成功')
            } else {
              this.$toast('删除失败')
            }
          } catch (error) {
            return error.message
          }
        })
        .catch(() => {
          this.$dialog.close()
        })
    },
    // 修改/查看
    async lookInfo (item, type) {
      this.lookData = item
      this.isLookShow = true
      this.id = item.id
      this.isLook = type
      if (type) {
        const data = await getUserInfo(item.user_id)
        this.userLook = data.data || {}
      }
      try {
        const data = await assessmentListDetails(item.id)
        this.userdata = data.data
        if (data.data.file_path === '0') {
          this.photopath = '未上传报告'
        } else {
          this.photopath = data.data.file_path
        }
        this.ListingData = data.data.ListingProgress
      } catch (error) {
        return error.message
      }
    },
    // 上传文件
    async beforeRead (file) {
      const data = await updateUserPhoto('files', file)
      if (data.error_code === 1) {
        this.userdata.file_path = data.data
      } else {
        this.$toast(data.info || '操作失败')
      }
      this.photopath = file.name
    },
    // 修改提交
    async ttjj () {
      const { data } = await assessmentListDetailsUp(this.id, this.userdata.file_path)
      this.$toast('修改成功')
      this.isLookShow = false
    },

    // 搜索框展示/隐藏
    searchCancel () {
      this.inpshow = !this.inpshow
      if (this.searchVal) {
        this.searchVal = ''
        this.isSearch = false
        this.onLoad(true)
      }
    },

    // 监听搜索内容
    async onSearch (val) {
      if (val === '') {
        this.$toast('请输入搜索内容')
        return false
      }
      this.searchVal = val
      this.isSearch = true
      this.onLoad(true)
    },
    // 点击要修改哪一项
    shows (item) {
      if (this.progressId === item.id) {
        this.progressId = '-1'
      } else {
        this.progressId = item.id
      }
      this.assprogress.id = item.id
    },
    // 修改进度
    async selectChange (e) {
      if (this.proxx === 'a') {
        this.assprogress.progress = '0'
      } else if (this.proxx === 'b') {
        this.assprogress.progress = '50'
      } else if (this.proxx === 'c') {
        this.assprogress.progress = '100'
      }
      const data = await modifyAssessmentListDetails(this.assprogress)
      this.lookInfo(this.lookData)
      this.proxx = 'z'
      this.progressId = '-1'
    }
  }
}
</script>

<style scoped lang="less">
.Evaluationmanagement {
  height: 100%;
  background-color: #f8f8f8;
  .MemberList {
    width: 702px;
    height: 231px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
    border-radius: 20px;
    margin: 20px auto;
    box-sizing: border-box;
  }
  /deep/ .van-nav-bar {
    line-height: 88px;
  }
  /deep/ .van-button--normal {
    padding: 0;
  }
  /deep/ .van-icon-search,
  /deep/ .van-icon-plus {
    font-size: 40px;
    color: #2dadb1 !important;
    font-weight: 700;
  }
  /deep/ .van-icon-plus {
    padding-left: 48px;
  }
  /deep/ .van-button {
    font-size: 28px;
    font-weight: 400;
    color: rgba(59, 59, 59, 1);
    width: 100px;
    height: 48px;
    line-height: 48px;
  }
  /deep/ .van-button:last-child {
    width: 160px;
  }
  .inp {
    width: 432px;
    height: 60px;
    background: rgba(243, 242, 242, 1);
    border-radius: 30px;
    padding-left: 30px;
    box-sizing: border-box;
    margin-bottom: 14px;
  }
  .head {
    display: flex;
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: rgba(45, 173, 177, 1);
    justify-content: space-around;
    div {
      font-size: 26px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    .name {
      padding-left: 17px;
    }
  }
  .list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 108px;
    line-height: 100px;
    font-size: 22px;
    font-weight: 400;
    padding: 10px 46px 0 32px;
    color: rgba(51, 51, 51, 1);
    box-sizing: border-box;
    div {
      width: 30%;
      text-align: center;
    }
    .time {
      width: 40%;
      line-height: 40px;
      text-align: left;
    }
    div:last-child {
      text-align: right;
    }
    .phone {
      margin-left: -15px;
    }
  }
  .btn {
    display: flex;
    justify-content: space-around;
    margin-top: 50px;
  }
  .operation {
    display: flex;
    width: 702px;
    height: 80px;
    line-height: 80px;
    background: rgba(45, 173, 177, 1);
    justify-content: space-around;
    margin: 0 auto;
    margin-top: -20px;
    div {
      font-size: 26px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
  /deep/ .van-popup--bottom {
    width: 95%;
    left: 18px;
    background-color: #f8f8f8;
  }

  .information {
    padding: 82px 40px 33px 40px;
    color: #666666;
    .photopath {
      width: 220px;
      margin-right: 30px;
      margin-left: 20px;
      background-color: #f8f8f8;
    }
    .btns {
      width: 560px;
      height: 80px;
      margin: 0 auto;
      margin-top: 88px;
      /deep/ .van-button {
        width: 100%;
        height: 100%;
      }
    }
    /deep/ .van-button {
      width: 160px;
    }
    /deep/ .van-radio__icon {
      width: 40px;
      height: 40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    /deep/ .van-radio-group {
      justify-content: space-around;
    }
    .technology {
      padding-left: 20px;
      font-size: 28px;
      font-weight: 400;
      color: #666666;
      margin-top: 33px;
      display: flex;
    }
    .progress {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 400px;
      margin-left: 30px;
      font-size: 28px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      .js {
        vertical-align: middle;
        font-size: 25px;
        width: 75%;
        display: inline-block;
        text-align: right;
      }
      /deep/ .van-icon {
        width: 13%;
        vertical-align: middle;
      }
      .progr {
        font-size: 18px;
        font-weight: 400;
        color: rgba(45, 173, 177, 1);
        margin: 0;
        text-align: center;
        margin-bottom: 8px;
      }
      .process {
        width: 50%;
        position: relative;
        .proce {
          position: absolute;
          width: 140px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 2px 6px 0px rgba(15, 15, 15, 0.23);
          padding: 10px;
          box-sizing: border-box;
          top: 40px;
          z-index: 1;
          select {
            width: 120px;
            font-size: 15px;
            height: 50px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            appearance: none;
            background: url("../../assets/images/select.png") no-repeat scroll
              85px center transparent;
            background-size: 26px 18px;
            padding-left: 10px;
          }
        }
      }
    }
    select {
      width: 400px;
      height: 60px;
      font-size: 28px;
      border: 2px solid rgba(39, 39, 39, 1);
      border-radius: 1px;
      background-color: #fff;
      appearance: none;
      background: url("../../assets/images/select.png") no-repeat scroll 350px
        center transparent;
      background-size: 26px 18px;
      padding-right: 30px;
      padding-left: 30px;
      font-size: 26px;
      text-align: center;
    }
    .basic {
      padding: 0 20px;
      span {
        margin-right: 25px;
      }
    }
    .looknew {
      color: #666666;
      text-align: center;
      padding-left: 50%;
      .van-icon-arrow {
        font-size: 20px;
      }
    }
    .docking {
      margin-top: 42px;
      .tel {
        display: block;
        width: 240px;
        height: 80px;
        line-height: 80px;
        background: rgba(20, 189, 123, 1);
        font-size: 34px;
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
      .foot {
        div {
          width: 240px;
          height: 80px;
          line-height: 80px;
          background: #2dadb1;
          font-size: 34px;
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          margin-left: 44px;
        }
        display: flex;
        padding: 0 40px;
        margin-top: 65px;
      }
      p {
        margin-bottom: 24px;
        margin-top: 0;
      }
    }
    p {
      font-size: 28px;
      font-weight: 400;
      color: #666666;
      margin-top: 33px;
    }
  }

  .m35 {
    margin-top: 35px;
    font-size: 28px;
    font-weight: 400;
    color: rgba(45, 173, 177, 1);
  }
  .active {
    color: #2dadb1 !important;
  }
  .sexs {
    color: #ccc;
  }
}
</style>
